/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import ShowcaseCollection from './showcase-collection';

export default ShowcaseCollection;



// WEBPACK FOOTER //
// ./src/containers/ShowcaseCollection/index.js